
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(9(2|20|48)|319)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
